var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ehr-context-banner"},[(_vm.isEhrOnlyDemo)?_c('ehr-context-banner-ehr-only'):_c('div',[(_vm.showInstructorEval)?_c('student-eval-control',{attrs:{"inEhr":""}}):_vm._e(),(_vm.showStudent)?_c('ehr-context-student'):_vm._e(),(_vm.isSeedEditing)?_c('ehr-context-case-study'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }